export enum ContractType {
  DataProvider = 'dataprovider',
  FCD = 'FCD'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/contracttype.ts